var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.925 16H64.2352C59.1984 16 55.1152 20.0832 55.1152 25.12V65.58C55.1152 70.6168 59.1984 74.7 64.2352 74.7H119.925C124.962 74.7 129.045 70.6168 129.045 65.58V25.12C129.045 20.0832 124.962 16 119.925 16Z",
    fill: "#7A5FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5762 26.0804C61.5762 23.9504 63.2961 22.2305 65.4261 22.2305H118.726C120.856 22.2305 122.576 23.9504 122.576 26.0804V59.4904C122.576 61.6204 120.856 63.3405 118.726 63.3405H65.4261C63.2961 63.3405 61.5762 61.6204 61.5762 59.4904V26.0804Z",
    fill: "#AEF9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.235 72.81C112.325 72.81 114.015 71.12 114.015 69.03C114.015 66.94 112.325 65.25 110.235 65.25C108.145 65.25 106.455 66.94 106.455 69.03C106.455 71.12 108.145 72.81 110.235 72.81Z",
    fill: "#A497FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.645 72.81C102.735 72.81 104.425 71.12 104.425 69.03C104.425 66.94 102.735 65.25 100.645 65.25C98.5553 65.25 96.8652 66.94 96.8652 69.03C96.8652 71.12 98.5553 72.81 100.645 72.81Z",
    fill: "#A497FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5449 35.1805C81.5449 30.9805 86.0348 28.3205 89.7148 30.3305L103.175 37.6905C107.005 39.7905 107.005 45.2905 103.175 47.3805L89.7148 54.7405C86.0348 56.7505 81.5449 54.0905 81.5449 49.8905V35.1705V35.1805Z",
    fill: "#80D8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVideo);
export default __webpack_public_path__ + "static/media/card_video.59998fa49a9262457d5fca7572896da5.svg";
export { ForwardRef as ReactComponent };